// extracted by mini-css-extract-plugin
export default {"logo":"login_logo__-SGLp","form":"login_form__gQ6uL","button":"login_button__GfJSd"};